import React, { useState } from "react";
// import { useNavigate } from "react-router-dom";
import "./AddSource.css";
import AddSourceModalContainer from "./components/AddSourceModalContainer";
import AddSourceMutation from "./mutations/AddSourceMutation";
import { commitLocalUpdate } from "react-relay";
import environment from "./Environment";
import { useMediaQuery } from "react-responsive";

function AddFeedBox(props) {
    // const navigate = useNavigate();
    const [feedLink, setFeedLink] = useState("");
    const [addFeedResponse, setAddFeedResponse] = useState("");
    const isSmallScreen = useMediaQuery({
        query: "(max-width: 900px)",
    });

    function onFeedInputChange(e) {
        e.preventDefault();
        setFeedLink(e.target.value);
        console.log(e.target.value);
    }

    function onSubmit(e) {
        e.preventDefault();
        setAddFeedResponse("Adding...");
        AddSourceMutation(feedLink, (source, error) => {
            if (source === null) {
                console.log("Unable to add feed!");
                // setAddFeedResponse("Unable to add Feed!");
                setAddFeedResponse(error);
            } else {
                console.log(source);
                setAddFeedResponse(`Added Feed - ${source.name}`);
                commitLocalUpdate(environment, (store) => {
                    const record = store.getRoot().getLinkedRecord("settings");
                    record.setValue(source.id, "selectedSubId");
                    record.setValue(source.name, "selectedSubName");
                    record.setValue(false, "isAddFeedBoxShown");

                    record.setValue(
                        true,
                        "isFullScreenAddSourceModalActivated"
                    );
                    record.setValue(true, "isAddSourceModalActivated");
                });
                // setSelectedSubId(source.id);
                // setSelectedSubName(source.name);
                // setIsModalActive(true);
            }
        });
    }

    return (
        <div>
            <form onSubmit={onSubmit}>
                <div className={`modal-message-box`}>
                    <input
                        placeholder="RSS/Atom Feed Link"
                        onChange={onFeedInputChange}
                        className={`standard-textfield-long search-textfield`}
                    />
                    <input
                        type="submit"
                        className="standard-action-button search-button"
                        value="Add"
                    />
                </div>

                <div style={{ fontSize: "14px" }}>{addFeedResponse}</div>
            </form>
            {/*

            <input
                onChange={onFeedInputChange}
                placeholder="RSS/Atom Feed Link"
                type="text"
                className="standard-textfield-long"
            />
            <div className="button-container">
                <button
                    className="standard-action-button"
                    onClick={addFeedOnClick}
                >
                    {" "}
                    Add Feed
                </button>
            </div>

            <div>
                <p>{addFeedResponse}</p>
            </div>
            */}
        </div>
    );
}

export default AddFeedBox;
